/**
 * Avatar Display Reducer
 * NgRx reducer for avatar display functionality.
 */

import { createReducer, on } from '@ngrx/store';
import * as AvatarDisplayActions from './avatar-display.actions';
import {
  AvatarDisplayState,
  initialAvatarDisplayState
} from './avatar-display.state';

export const avatarDisplayReducer = createReducer(
  initialAvatarDisplayState,

  /**
   * Check Avatar Status.
   */
  on(
    AvatarDisplayActions.checkAvatarStatus,
    (state): AvatarDisplayState => ({
      ...state,
      loading: {
        ...state.loading,
        fetchingStatus: true
      },
      error: null
    })
  ),

  on(
    AvatarDisplayActions.checkAvatarStatusSuccess,
    (state, { status }): AvatarDisplayState => ({
      ...state,
      status: {
        processing: status.processing,
        current: status.current,
        lastFailed: status.lastFailed
      },
      loading: {
        ...state.loading,
        fetchingStatus: false
      },
      error: null
    })
  ),

  on(
    AvatarDisplayActions.checkAvatarStatusFailure,
    (state, { error }): AvatarDisplayState => ({
      ...state,
      loading: {
        ...state.loading,
        fetchingStatus: false
      },
      error
    })
  ),

  /**
   * Fetch Avatar Image.
   */
  on(
    AvatarDisplayActions.fetchAvatarImage,
    (state): AvatarDisplayState => ({
      ...state,
      loading: {
        ...state.loading,
        fetchingImage: true
      },
      error: null
    })
  ),

  on(
    AvatarDisplayActions.fetchAvatarImageSuccess,
    (state, { image }): AvatarDisplayState => ({
      ...state,
      image: {
        imageUrl: image.imageUrl,
        isDefault: image.isDefault,
        width: image.width,
        height: image.height
      },
      loading: {
        ...state.loading,
        fetchingImage: false
      },
      error: null
    })
  ),

  on(
    AvatarDisplayActions.fetchAvatarImageFailure,
    (state, { error }): AvatarDisplayState => ({
      ...state,
      loading: {
        ...state.loading,
        fetchingImage: false
      },
      error
    })
  ),

  /**
   * Refresh Avatar On Notification
   * This doesn't change state directly - it's handled by effects.
   */
  on(
    AvatarDisplayActions.refreshAvatarOnNotification,
    (state): AvatarDisplayState => state
  ),

  /**
   * Invalidate Avatar Cache
   * This doesn't change state directly - it's handled by effects.
   */
  on(
    AvatarDisplayActions.invalidateAvatarCache,
    (state): AvatarDisplayState => state
  ),

  /**
   * Clear Avatar State.
   */
  on(
    AvatarDisplayActions.clearAvatarState,
    (): AvatarDisplayState => ({
      status: {
        processing: null,
        current: null,
        lastFailed: null
      },
      image: {
        imageUrl: null,
        isDefault: false,
        width: undefined,
        height: undefined
      },
      loading: {
        fetchingStatus: false,
        fetchingImage: false
      },
      error: null
    })
  )
);
